/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 5/16/15,
 * Refactored by kyang on 12/13/19
 */

function TimecodeInputController (
    this: JS5Object,
    $element: JS5Object
) {

    /**
     * Add extra 0s in front of timecode's strings.
     * (This modifies the parameter)
     */
    const padTimecodeObj = (timecodeObj: JS5Object) => {
        timecodeObj.hours = timecodeObj.hours.padStart(2, '0');
        timecodeObj.minutes = timecodeObj.minutes.padStart(2, '0');
        timecodeObj.seconds = timecodeObj.seconds.padStart(2, '0');
        timecodeObj.frames = timecodeObj.frames.padStart(2, '0');
    };

    //===================//
    // NgModel Functions //
    //===================//

    /**
     * Reset displayed (scope) values based on $viewValue
     */
    const renderModelCtrl = () => {
        if (this.ngModelCtrl.$viewValue) {
            this.hours = this.ngModelCtrl.$viewValue.hours;
            this.minutes = this.ngModelCtrl.$viewValue.minutes;
            this.seconds = this.ngModelCtrl.$viewValue.seconds;
            this.frames = this.ngModelCtrl.$viewValue.frames;
        } else {
            this.hours = '';
            this.minutes = '';
            this.seconds = '';
            this.frames = '';
        }
    };

    const stringToTimecodeObj = (modelValue: string) => {
        if(modelValue) {
            let parts = modelValue.split(/[:|;]/);
            return {
                hours: parts[0],
                minutes: parts[1],
                seconds: parts[2],
                frames: parts[3]
            };
        }
        return null;
    };

    const timecodeObjToString = (timecodeObj: JS5Object) => {
        // Copy in cleaned up view values to handle cases where multiple component parts are changed
        // padding only applies to the copied timecodeObj, not the parameter object
        let parsedTimecodeObj = JSON.parse(JSON.stringify(timecodeObj));
        padTimecodeObj(parsedTimecodeObj);
        return parsedTimecodeObj.hours + ':' + parsedTimecodeObj.minutes + ':' +  parsedTimecodeObj.seconds + ':' + parsedTimecodeObj.frames;
    };


    //===================//
    // Template Response //
    //===================//

    this.timecodeChanged = (currentComponent: string, nextComponent: string) => {
        let newValue = this[currentComponent].replace(/\D/g, '');

        // User typed in field & reaches length 2
        if (newValue.length === 2) {
            $element.find('#'+ nextComponent)[0].focus();
        // User re-enters field and starts typing
        } else if (newValue.length > 2) {
            newValue = newValue.slice(2, 4);
        }
        this[currentComponent] = newValue;

        this.ngModelCtrl.$setViewValue({
            hours: this.hours,
            minutes: this.minutes,
            seconds: this.seconds,
            frames: this.frames
        });
        // Update timecodeCtrl's copy as well
        this.ngModelCtrl.$render();
    };

    this.onPartExit = (event: JS5Object) => {
        // Update view value, model is already correct
        padTimecodeObj(this.ngModelCtrl.$viewValue);
        // Update timecodeCtrl's copy as well
        this.ngModelCtrl.$render();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.ngModelCtrl.$render = renderModelCtrl;
        // Called whenever the model is changed programmatically and also on initial loading.
        // $viewValue is set == Returned value
        this.ngModelCtrl.$formatters.push(stringToTimecodeObj);
        // Called when the view value is set manually as done in timecodeChanged
        // $modelValue is set == Returned value
        this.ngModelCtrl.$parsers.push(timecodeObjToString);
    }
}


angular
    .module('prism-ui.components')
    .component('timecodeInput', {
        bindings: {
            componentDisabled: '=ngDisabled',
            dropFrame: '=',
            rootClass: '@',
        },
        require: {
            ngModelCtrl: '^ngModel'
        },
        controller: TimecodeInputController,
        templateUrl: 'components/visual/timecode/timecodeinput-template.html',
    });
